const animations = {}
export default animations

// TODO: At the end of this refactor, make this the only
// canonical format for deltastages! No need to use
// action.type as a key into what animation you want.
// All animations can be delivered in this flexible format!!!
animations["invoke skill"] = (step) => {
    return {
        "isImportant": true,
        // if you're ever wondering what a deltastage is nowadays,
        // this is a big clue: it's a keyframe to be used in an animation sequence.
        "keyframes": step.deltastages.map((deltastage) => {
            deltastage.mark = deltastage.mark || 0
            if(deltastage instanceof Function) {
                return deltastage()
            }
            if(deltastage.isSkipped == true) return
            return deltastage // just naively performs it
            // TODO: I wish the naive perform of it would include a delta.editStage, right??
            // I currently have to rewrite the setting of properties in the Director.performStage :<
            // I get that I need to tween it! But this is different, right?
        })
    }
}

animations["StartDialogue"] = (step) => {
    const dialogue = step.deltastages[0].dialogue

    let mark = 0
    const keyframes = []
    if(dialogue.text != undefined) {
        const BLIP_SPEED = 25
        const COMMA_SPEED = 80
        const PUNCTUATION_SPEED = 200
        for(let index = 0; index < dialogue.text.length; index += 1) {
            const character = dialogue.text[index]
            const nextCharacter = dialogue.text[index]
            // TODO: play sound effects with each new index blit (if it isn't whitespace)
            keyframes.push({
                "mark": mark,
                "dialogue": {
                    "type": dialogue.type, // the modal type
                    "text": dialogue.text,
                    "tags": dialogue.tags,
                    "data": dialogue.data,
                    "speakingCharacter": dialogue.speakingCharacter,
                    "index": index,
                    // TODO: Hey, if you want to animate MORE things in the text schema... you'll need to include it here?
                    // or fix the dialogue delta to not override but mutate with a partial delta (just the progress)
                },
            })
            if(character != " ") {
                keyframes.push({
                    "mark": mark,
                    "audio": {"triggerKey": "Dialogue:Blip"},
                })
            }
            mark += BLIP_SPEED
            if(character == ",") {
                mark += COMMA_SPEED
            }
            if((character == "." || character == "!") == true
            && (nextCharacter == "." || nextCharacter == "!") != true) {
                mark += PUNCTUATION_SPEED
            }
        }
        step.deltastages.slice(1).forEach((deltastage) => {
            deltastage.mark = deltastage.mark || 0
            if(deltastage instanceof Function) {
                return deltastage()
            }
            if(deltastage.isSkipped == true) return
            keyframes.push(deltastage) // just naively performs it
            // TODO: I wish the naive perform of it would include a delta.editStage, right??
            // I currently have to rewrite the setting of properties in the Director.performStage :<
            // I get that I need to tween it! But this is different, right?
        })
        if(dialogue?.data?.isAutoending != true) {
            keyframes.push({
                "mark": mark,
                "duration": Infinity,
            })
        }

        return {
            // "isImportant": true,
            // "duration": Infinity,
            "keyframes": keyframes,
            "minduration": mark,
            // "keyframes": [
            //     {
            //         "mark": 0,
            //         "duration": Infinity,
            //         "dialogue": dialogue,
            //     }
            // ]
        }
    } else {
        // keyframes.push({
        //     "mark": mark,
        //     "dialogue": dialogue
        // })
    }
}

animations["Dialogue"] = (step) => {
    let duration = 0
    step.deltastages.forEach((deltastage) => {
        duration = Math.max(duration, deltastage.mark)
    })
    return {
        "keyframes": step.deltastages,
        "minduration": duration,
    }
}
